// Renders a fixed signal through an OfflineAudioContext and sums the tail samples.
// Different audio implementations produce slightly different float sums — stable per-device.
export function renderAudioFingerprint(): Promise<string> {
  return new Promise((resolve) => {
    try {
      const OfflineAudioContextCtor: typeof OfflineAudioContext =
        (window as any).OfflineAudioContext || (window as any).webkitOfflineAudioContext;
      if (!OfflineAudioContextCtor) {
        resolve('');
        return;
      }

      const ctx = new OfflineAudioContextCtor(1, 5000, 44100);

      const oscillator = ctx.createOscillator();
      oscillator.type = 'triangle';
      oscillator.frequency.value = 10000;

      const compressor = ctx.createDynamicsCompressor();
      compressor.threshold.value = -50;
      compressor.knee.value = 40;
      compressor.ratio.value = 12;
      compressor.attack.value = 0;
      compressor.release.value = 0.25;

      oscillator.connect(compressor);
      compressor.connect(ctx.destination);
      oscillator.start(0);

      let settled = false;
      const settle = (value: string) => {
        if (settled) return;
        settled = true;
        resolve(value);
      };

      const renderPromise = ctx.startRendering();
      if (renderPromise && typeof renderPromise.then === 'function') {
        renderPromise.then(buffer => settle(sumTail(buffer.getChannelData(0)))).catch(() => settle(''));
      } else {
        (ctx as any).oncomplete = (event: OfflineAudioCompletionEvent) =>
          settle(sumTail(event.renderedBuffer.getChannelData(0)));
      }

      setTimeout(() => settle(''), 1000);
    } catch {
      resolve('');
    }
  });
}

function sumTail(channel: Float32Array): string {
  let sum = 0;
  for (let i = 4500; i < 5000; i++) sum += Math.abs(channel[i]);
  return sum.toString();
}
